import {takeEvery, takeLatest} from 'redux-saga/effects';
import {loadNextSaga} from "./_sagas/loadNext.saga";
import {reviewActions} from "./review.slice";
import {submitReviewSaga} from "./_sagas/submitReview.saga";
import {showAnswerSaga, showSubcardAnswerSaga} from "./_sagas/showAnswer.saga";
import {initializeSaga} from "./_sagas/initialize.saga";

export function* reviewSaga() {
    yield takeEvery(reviewActions.initialize.type, initializeSaga);
    yield takeEvery(reviewActions.loadNext.type, loadNextSaga);
    yield takeEvery(reviewActions.showAnswer.type, showAnswerSaga);
    yield takeEvery(reviewActions.submit.type, submitReviewSaga);
    yield takeLatest(reviewActions.showSubcardAnswer.type, showSubcardAnswerSaga);
}
